<template>
	<div class="KafkaTopics">
		<!-- <h3>KafkaTopics ДАННЫЕ В ТОПИКАХ КАФКИ</h3> -->
		<card class="getTopics">
			<div class="row mx-0 align-items-center mb-3">				
				<el-select
					class="col-12 col-md-6 select-primary"
					size="large"
					placeholder="Выбрать топик"
					v-model="topicSelected"
				>
					<el-option
						v-for="(el_opt, el_index) in masTopics"
						class="select-primary"
						:value="el_opt.value"
						:label="el_opt.label"
						:key="el_index"
					>
					</el-option>
				</el-select>
				<div class="col-12 col-md-6 mt-2 mt-lg-0">
					<button class="btnChange btn btn-simple btn-success mx-auto my-0" @click="getTest()">Получить топик</button>
				</div>
			</div>
		</card>

		<card class="showTopics">
			<pre>{{ ApiData }}</pre>
			
		</card>

		
<!-- 
		<card>
			<button class="btnStart btn btn-simple btn-success col-sm-12 col-lg-2 m-0 mb-3" @click="StartTest()">Запустить тесты</button>
			<el-table ref="multipleTable" @selection-change="handleSelectionChange" :row-class-name="tableRowClassName" :data="ApiData">
				<el-table-column
					type="selection"
					width="55">
				</el-table-column>
				<el-table-column
					min-width="55"
					sortable
					label="№"
					property="id"
				></el-table-column>
				<el-table-column
					min-width="130"
					label="Название теста"
					property="testname"
				></el-table-column>
				<el-table-column
					min-width="130"
					label="Запрос"
					property="req"
				></el-table-column>
				<el-table-column
					min-width="130"
					label="Ответ ожидаемый"
					property="expected_response"
				></el-table-column>
				<el-table-column
					min-width="130"
					label="Проверка ответа"
					property="check_function"
				></el-table-column>
				<el-table-column
					min-width="80"
					label="Удалить"
					property="del"
				>
					<template slot-scope="scope">
						<button class="btn btn-simple btn-danger" @click="DelTest(scope.row.id)">
							<i class="tim-icons icon-simple-remove"></i>
						</button>
					</template>	
				</el-table-column>
			</el-table>
		</card> -->

	</div>
</template>
<script>
import { Select, Option, Table, TableColumn } from 'element-ui';

export default {
	name: 'kafkatopics-page',
	components: {
		[Option.name]: Option,
		[Select.name]: Select,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
	},
	data() {
		return {
			ApiData: [],
			masTopics: [
				{label:'MainArmanTopic', value:'MainArmanTopic'},
				{label:'ТЕСТ MainArmanTopic', value:'MainArmanTopicTest'},
			],
			topicSelected: '',
			// objNewTest:{
			// 	'testname':'',
			// 	'req':'',
			// 	'expected_response':'',
			// 	'check_function':'',
			// },
			// masTableSelection: [],
			// masCheckFunctions: [
			// 	{value: '=', label: '=',},
			// 	{value: 'data_exists', label: 'data_exists',},
			// ],
		};
	},
	methods: {
		getTest(){
			// console.log('getTest func');
			this.$GVO.ApiCall('GET',{obj:'KafkaTopics',flt:{topic:this.topicSelected}})
			.then((objApi) => {
				if(objApi.success === true){
					// console.log('objApi.data ' + objApi.data.payload);
					if(objApi.data){
						// console.log('objApi.data ' + objApi.data);
						
						// this.ApiData = objApi.data;
						this.ApiData = this.$GVO.unlinkObject(objApi.data);
						
					}
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		// AddTest(){
		// 	this.$GVO.ApiCall('INS',{obj:'AutoTest',iData:{...this.objNewTest}})
		// 	.then((objApi) => {
		// 		if(objApi.success === true){
		// 			this.objNewTest = {
		// 				'testname':'',
		// 				'req':'',
		// 				'expected_response':'',
		// 				'check_function':'',
		// 			}
		// 			this.getApiData();
		// 		}
		// 	}).catch(errorObjApi => console.log(errorObjApi));
		// },
		// StartTest(){
		// 	if(this.masTableSelection.length>0){
		// 		for (let i = 0; i < this.masTableSelection.length; i++) {
		// 			//console.log(this.masTableSelection[i]);
		// 			let objTest = this.$GVO.unlinkObject(this.masTableSelection[i]);
		// 			this.$GVO.axiosSend(this.masTableSelection[i].req)
		// 			.then((objApi) => {
		// 				//console.log(objApi);
		// 				//console.log(objTest);
		// 				this.CheckTest(objTest,objApi);
		// 			}).catch(errorObjApi => console.log(errorObjApi));
		// 		}
		// 	}
		// },
		// StartTestNoCreate(){
		// 	//this.objNewTest
		// 	if(this.objNewTest.req !=''){
		// 		let objTest = this.$GVO.unlinkObject(this.objNewTest);
		// 			this.$GVO.axiosSend(this.objNewTest.req)
		// 			.then((objApi) => {
		// 				//console.log(objApi);
		// 				//console.log(objTest);
		// 				alert(this.CheckTest(objTest,objApi,true));
		// 			}).catch(errorObjApi => console.log(errorObjApi));
		// 	}
		// },
		// DelTest(test_id){
		// 	this.$GVO.ApiCall('DEL',{obj:'AutoTest',flt:{'id':test_id}})
		// 	.then((objApi) => {
		// 		if(objApi.success === true){
		// 			this.getApiData();
		// 		}
		// 	}).catch(errorObjApi => console.log(errorObjApi));
		// },
		// CheckTest(objTestData,objRetData,bSingle=false){
		// 	let bRes = false;

		// 	if(objTestData.check_function == '='){
		// 		if(JSON.stringify(objRetData) === objTestData.expected_response) bRes = true;
		// 	}else if(objTestData.check_function == 'data_exists'){
		// 		if(objRetData.result.success == true && objRetData.result.data.length > 0) bRes = true;
		// 	}else{
		// 		return bRes;
		// 	}

		// 	if(!bSingle){
		// 		for (let i = 0; i < this.ApiData.length; i++) {
		// 			if(this.ApiData[i].id == objTestData.id){
		// 				this.ApiData[i]['test_result'] = bRes;
		// 				this.toggleSelection([this.ApiData[i]]);
		// 			}
		// 		}
		// 		this.$refs.multipleTable.clearSelection();
		// 		//this.$refs.multipleTable.doLayout();
		// 	}

		// 	return bRes;
		// },
		// handleSelectionChange(val) {
		// 	this.masTableSelection = val;
		// },
		// tableRowClassName({row, rowIndex}) {
		// 	if (typeof row.test_result != 'undefined') {
		// 		if(row.test_result==false){
		// 			return 'table-danger';
		// 		} else if (row.test_result==true) {
		// 			return 'table-success';
		// 		}
		// 	}
		// 	return '';
		// },
		// toggleSelection(rows) {
		// 	if (rows) {
		// 		rows.forEach(row => {
		// 			this.$refs.multipleTable.toggleRowSelection(row);
		// 		});
		// 	} else {
		// 		this.$refs.multipleTable.clearSelection();
		// 	}
		// },
	},
	mounted() {
		// this.getApiData();
	}
};
</script>

<style scoped>
.getTopics {

}
</style>
